( function($) {
	$( document ).on( 'change', '#ac_needs input', function( event ) {
		event.preventDefault();
		$( '.charter-single' ).hide();
		$( '.fleet-slider' ).hide();

		const features_passenger_capacity = $( 'input[name="features_passenger_capacity"]:checked' ).val();

		const max_range_scope = $( 'input[name="max_range_scope"]:checked' ).val();

		const amenities = $( 'input[name="amenities"]:checked' ).map( function() {
			return this.value;
		}).get().join( ', ' );

		const fleet_data = {
			'action'                     : 'charter_fleet_filtering',
			'nonce'                      : charterFilter.nonce,
			'features_passenger_capacity': features_passenger_capacity,
			'max_range_scope'            : max_range_scope,
			'amenities'                  : amenities
		}

		$.ajax({
			type   : 'POST',
			url    : charterFilter.ajaxurl,
			data   : fleet_data,
			success: function( result ) {
				$( '.search-results-wrapper' ).html( result ).show();
			}
		});
	});

	$( document ).on( 'click', '.reset-search', function( event ) {
		event.preventDefault();
		$( '#ac_needs' ).trigger( 'reset' );
		$( '.charter-single' ).show();
		$( '.fleet-slider' ).show();
		$( '.search-results-wrapper' ).empty().hide();
	});
} )(jQuery);
